import React from "react";

// components
import Navbar from "../../components/Navbar";
import Breadcumb from "../../components/breadcumb";

import ScheduleMeeting from "../../components/ScheduleMeeting";
import FooterSection from "../../components/Footer";
import FloatingMenu from "../../components/FloatingMenu/FloatingMenu";
import saveToApm from "../../apm";
import { useEffect} from "react";

const ScheduleMeetingMainComponent = () => {
    useEffect(() => {
        saveToApm("Booking Meeting Page (/scheduleMeeting)");
    }, []);
  return (
    <div>
      <Navbar />
      <Breadcumb bdtitle={"Schedule a Meeting"} bdsub={"Book a Meeting"} />
      <ScheduleMeeting />
      <FloatingMenu />
      <FooterSection />
    </div>
  );
};

export default ScheduleMeetingMainComponent;
